import { memo } from 'react';
import styled from 'styled-components';

import error2x from '@wecasa/common/src/assets/images/error@2x.jpg';
import error3x from '@wecasa/common/src/assets/images/error@3x.jpg';
import error from '@wecasa/common/src/assets/images/error.jpg';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import Alert from '@wecasa/web-ui/src/components/alert/alert';
import Title from '@wecasa/web-ui/src/components/base-text/variants/title';
import Image from '@wecasa/web-ui/src/components/image/image';
import { DEFAULT_MARGIN } from '@wecasa/web-ui/src/constants/styles';

const t = translate('components.error_page');

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${toRem(DEFAULT_MARGIN)};
`;

const StyledTitle = styled(Title.SM)`
  margin: ${toRem(DEFAULT_MARGIN)} 0;
`;

type ErrorPageProps = {
  errors?: string[];
  testId?: string;
};

const ErrorPage = ({ errors = [], testId }: ErrorPageProps) => (
  <Container data-testid={testId}>
    <Title.XXXL>{t('.title').toUpperCase()}</Title.XXXL>
    <StyledTitle>{t('.message1')}</StyledTitle>
    <Image src={error} double={error2x} triple={error3x} alt={t('.title')} />
    <StyledTitle>{t('.message2')}</StyledTitle>
    <Alert type='error' content={errors} />
  </Container>
);

export default memo(ErrorPage);
